import React from 'react';
import { useQuery, NetworkStatus } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import PopularProducts from './PopularProducts';
import CollaborationPage from '../../containers/CollaborationPage';

import { POPULAR_PRODUCTS, NEW_BOOKS } from './queries';
import BookList from '../../components/BookList';

const Home = () => {
  const products = useQuery(POPULAR_PRODUCTS, {
    variables: {
      pagination: {
        offset: 0,
        limit: 8,
      },
    },
  });

  const limit = 10;

  const books = useQuery(NEW_BOOKS, {
    notifyOnNetworkStatusChange: true,
    variables: {
      pagination: {
        offset: 0,
        limit,
      },
      sorting: {
        orderBy: 'updatedAt',
        order: 'DESC',
      },
    },
  });

  const queries = [books, products];
  const loading = queries.some(
    (q) => q.loading && q.networkStatus === NetworkStatus.loading,
  );
  const error = queries.some((q) => q.error);

  return (
    <CollaborationPage loading={loading} error={error} className="pt-1">
      <PopularProducts items={products?.data?.listPopularProducts} />
      <BookList
        limit={limit}
        title={<FormattedMessage defaultMessage="Senast upplagt" />}
        subtitle={
          <FormattedMessage defaultMessage="Här är några av de senast upplagda böckerna." />
        }
        items={books?.data?.listBooks || []}
        loading={books?.loading}
        networkStatus={books?.networkStatus}
        fetchMore={books.fetchMore}
      />
    </CollaborationPage>
  );
};

export default Home;
